module.exports = {"410902001":"中原路街道","410902002":"胜利路街道","410902003":"建设路街道","410902004":"人民路街道","410902005":"大庆路街道","410902006":"黄河路街道","410902007":"任丘路街道","410902008":"长庆路街道","410902009":"濮东街道","410902101":"岳村镇","410902203":"孟轲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410902.json
// module id = 1730
// module chunks = 0